const PYTHAGOREAN_LEGS = [
  [3, 4],
  [5, 12],
  [6, 8],
  [8, 15],
  [9, 12],
  [12, 16],
];

const NON_PYTHAGOREAN_LEGS = [
  [2, 3],
  [2, 5],
  [3, 5],
  [4, 5],
  [4, 7],
  [5, 6],
];

const pick = (items) => items[Math.floor(Math.random() * items.length)];

const ANGLE_LABELS = ["\\alpha", "\\beta", "\\gamma"];

export function generateAngleLabel() {
  return pick(ANGLE_LABELS);
}

export function generateRightTriangleLegs() {
  const isPythagorean = Math.random() < 2 / 3;
  const [first, second] = pick(
    isPythagorean ? PYTHAGOREAN_LEGS : NON_PYTHAGOREAN_LEGS
  );
  const swap = Math.random() < 0.5;
  return {
    a: swap ? second : first,
    b: swap ? first : second,
    isPythagorean,
  };
}
